import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import PushingServices from "../based/services/PushingServices";
import TFUSelect from "../based/inputs/TFUSelect";

function PartnerColorModal({ show, onClose, onSave }) {
    const [colorDropdown, setColorDropdown] = useState(false);
    const [colorCode, setColorCode] = useState("");

    useEffect(() => {
        getColorDropdown();
    }, []);

    const getColorDropdown = async () => {
        const [err, data] = await PushingServices.GetColorValue();
        if (!err && data) {
            setColorDropdown(data);
        } else {
            setColorDropdown([]);
        }
    };

    return (
        <Wrapper>
            <CommonModal
                show={show}
                onClose={onClose}
                size="md"
                onSave={() => {
                    let find = colorDropdown.find((x) => x.value == colorCode);
                    onSave(find.value, find.text);
                    setColorCode("");
                }}
            >
                <div className="form-group">
                    <label htmlFor="">Chọn màu</label>
                    <TFUSelect value={colorCode} onChanged={(value) => setColorCode(value)} options={colorDropdown} placeholder="--Chọn màu--" />
                </div>
            </CommonModal>
        </Wrapper>
    );
}

export default PartnerColorModal;

const Wrapper = styled.div``;
